import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  handleHowItWorksToggle,
  setERPSyncStatus,
  setHowItWorksToggleFalse,
} from "../../../redux/slice/homeSlice";
import TimeSlotModal from "../../modal/TimeSlotModal";
import ReferralSuccessModal from "../../modal/ReferralSuccessModal";
import { setHeading } from "../../../redux/slice/headerSlice";
import { ValidatorForm } from "react-form-validator-core";
import SelectValidator from "../../partial/SelectValidator";
import { AddReferralData } from "../../auth/auth";
import swal from "sweetalert";
import Loader from "../../partial/Loader";
import { selectValueGetter } from "../../../utils/helper";

const ERPSyncEnable = () => {
  const formRef = useRef();
    const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const howItWorksToggle = useSelector((state) => state.home.howItWorksToggle);
 const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    dispatch(setHeading("ERP Sync"));
    ValidatorForm.addValidationRule("isERPToolSelected", (value) => {
      return state.eRPTool !== "";
    });
    ValidatorForm.addValidationRule("isTimeSlotSelected", (value) => {
      return state.timeSlot !== "";
    });
    return () => {
      ValidatorForm.removeValidationRule("isERPToolSelected");
      ValidatorForm.removeValidationRule("isTimeSlotSelected");
    };
  }, []);

  const [state, setState] = useState({
    customerid: localStorage.getItem("customerid"),
    eRPTool: "",
    timeSlot: "",
  });

  const timeSlotOption = [
        { value: "", label: "Select" },
    { value: "09:00 AM - 11:00 AM", label: "09:00 AM - 11:00 AM" },
    { value: "11:00 AM - 01:00 PM", label: "11:00 AM - 01:00 PM" },
    { value: "02:00 PM - 04:00 PM", label: "02:00 PM - 04:00 PM" },
    { value: "04:00 PM - 06:00 PM", label: "04:00 PM - 06:00 PM" },
  ];

  const { eRPTool, timeSlot } = state;

  const handleERPToolSelect = (tool) => {
    setState({ ...state, eRPTool: tool });
  };

  const handleTimeSlotSelect = (e) => {
    setState({ ...state, timeSlot: e.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const formValid = formRef.current.isFormValid();
    if (!formValid) {
      swal({
        position: "center",
        icon: "error",
        title: "Please select both an ERP tool and a time slot",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    setLoader(true);
    try {
      let token = await JSON.parse(localStorage.getItem("token_gen"));
      let response = await AddReferralData(token.access_token, state);
      setLoader(false);
      if (response?.message === "Success") {
           setShowPopup(true); 
        setState({ ...state, eRPTool: "", timeSlot: "" });
      } else {
        swal({
          position: "center",
          icon: "error",
          title: response?.message || "Something went wrong",
          showConfirmButton: false,
          timer: 5000,
        });
      }
    } catch (error) {
      setLoader(false);
      swal({
        position: "center",
        icon: "error",
        title: "An error occurred. Please try again.",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setHowItWorksToggleFalse());
    };
  }, []);
   const handleClosePopup = (e) => {
    e.preventDefault();
    setShowPopup(false); 
    navigate("/home"); 
  };

  return (
    <main>
      {loader && <Loader />}
      <div className="route-invoice bluebg">
        <h4 className="route-invoice-top">
          <img src="/images/erp_sync.svg" alt="ERP Sync" />
          Enable ERP Sync
        </h4>
        <p>
          Earn up to ₹1,000 every day by keeping
          your ERP synced with Progcap
        </p>
      </div>

      <div className="route-form">
        <h5>Raise a Sync Request</h5>
        <ValidatorForm ref={formRef} onSubmit={onSubmit}>
          <div className="formbox">
            <span>Select ERP Tool</span>
            <ul className="erp_list">
              <li
                data-tool="tally"
                onClick={() => handleERPToolSelect("tally")}
                className={eRPTool === "tally" ? "selected" : ""}
              >
                <img src="/images/tally.png" alt="Tally" />
              </li>
              <li
                data-tool="busy"
                onClick={() => handleERPToolSelect("busy")}
                className={eRPTool === "busy" ? "selected" : ""}
              >
                <img src="/images/busy.png" alt="Busy" />
              </li>
            </ul>
            <input
              type="hidden"
              value={eRPTool}
              validators={["isERPToolSelected"]}
              errorMessages={["Please select an ERP tool"]}
            />
          </div>
          <div className="formbox">
            <span>Preferred Time Slot</span>
            <SelectValidator
              name="timeSlot"
              id="select_time_slot"
              options={timeSlotOption}
              value={selectValueGetter(timeSlotOption, timeSlot)}
              onChange={handleTimeSlotSelect}
              validators={["required"]}
              errorMessages={["Please select a time slot"]}
            >
              Select time slot
            </SelectValidator>
          </div>
          <div className="formbox">
            <button
              type="submit"
              className={`btn btn-block btn-blue ${
                !eRPTool ? "btn-disabled" : ""
              }`}
              disabled={!eRPTool}
            >
              Submit ERP Sync Request
            </button>
          </div>
        </ValidatorForm>
      </div>

      <div className="how-it-works">
        <div
          className={`how-it-works-heading ${howItWorksToggle ? "move" : ""}`}
          onClick={() => dispatch(handleHowItWorksToggle())}
        >
          How it works
        </div>
        <div
          className={`how-it-works-results blue ${howItWorksToggle ? "active" : ""}`}
        >
          <ul>
            <li>
              Submit your ERP sync request by selecting your ERP tool and
              providing contact details
            </li>
            <li>
              Our Team will reach out to you in your selected time slot to
              enable the sync
            </li>
            <li>
              Once synced, you'll automatically earn 1,000 points every day
            </li>
          </ul>
        </div>
      </div>

      <div className="route-pushBox yellowbg mb-15">
        <div className="route-pushBox-left">
          <img src="/images/erp_sync-yellow.svg" alt="Important" />
        </div>
        <div className="route-pushBox-right">
          <h4>Important Note</h4>
          <p>
            Points earning will stop if the ERP sync is disabled or interrupted.
            Keep your ERP synced continuously to earn points every day.
          </p>
        </div>
      </div>
      <TimeSlotModal />
       {showPopup && (
              <div className="popup show" id="referral_successful">
                <div className="popup-box">
                  <Link
                    className="close-popup"
                    id="close_referral_successful"
                    onClick={handleClosePopup}
                  >
                    X
                  </Link>
                  <div className="popup-box-inner">
                    <img src="/images/successful.png" className="success" alt="" />
                    <h5 className="big">Congratulations!</h5>
                    <p className="small">
                     your ERP sync is active and your`re earning   <br /> points daily
                     <br />
                     
                    </p>
                  </div>
                </div>
              </div>
            )}
    </main>
  );
};

export default ERPSyncEnable;